import React from 'react';
import PropTypes from 'prop-types';
import TagPill from '../../common/TagPill';

function InfoComponent({ thumbnail, tags = [] }) {
    tags = tags ? tags : [];
    tags = Array.isArray(tags) ? tags : tags.split(',');

    const pills =
        tags &&
        tags.map((tag, index) => {
            return <TagPill key={`tag-${index}`} label={tag} />;
        });
    return (
        <div className="mapCard">
            <img src={thumbnail} alt="image" className="preview" />
            <div className="contentHolder clearfix">
                {tags.length ? (
                    <i
                        className="icon-tags"
                        style={{ fontSize: 18, paddingRight: 5 }}
                    ></i>
                ) : null}
                {pills}
            </div>
        </div>
    );
}

InfoComponent.propTypes = {
    // litter thumnail to be displayed in map marker
    thumbnail: PropTypes.string.isRequired,
    // array of litter tags to be displayed inside marker
    tags: PropTypes.arrayOf(PropTypes.string),
};

export default InfoComponent;
